import { createUseStyles } from 'react-jss';
export const useCheckboxStyles = createUseStyles(() => ({
    checkbox: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: '0.3rem',
        border: '1px solid #e5e7eb',
        backgroundColor: '#fff',
        width: '1.2em',
        height: '1.2em',
        color: 'white',
        '&[data-checked]': {
            backgroundColor: '#2563eb'
        },
        '&[data-indeterminate]': {
            backgroundColor: '#2563eb'
        }
    },
    checkboxIcon: {
        padding: '0.15em 0.175em 0.2em 0.15em',
    }
}));
